import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { HomeService } from '../_services/home.service';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.css']
})
export class ErrorPageComponent implements OnInit {

  constructor(private router: Router, private homeService: HomeService) { }

  ngOnInit(): void {
  }
}
